import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as newsActions from '../../actions/news';
import * as UserActions from '../../actions/user';
import * as AnalyticsAction from '../../actions/analytics';
import { MenuItem, Nav, NavDropdown, Navbar, NavItem } from 'react-bootstrap';
import { IndexLinkContainer, LinkContainer } from 'react-router-bootstrap';
import C from '../../constants/routes';
import IndexStyle from './style.scss';
import defaultUserPhoto from '../../images/user.png';
import C_APP from '../../constants/app';
import C_USER from '../../constants/user';
import C_HEADER from '../../constants/header';
import C_NEWS from '../../constants/news';
import C_ROUTES from '../../constants/routes';
import C_A from '../../constants/analytics';
import intlC from '../../constants/intl';
import { axiosInstance } from '../../utils/helpers';
import styled from 'styled-components';
import { getContrastWhiteBlack } from '../../utils/helpers';

const StyledDiv = styled.div`
  /* styled comp */
  .navbar-inverse {
    background-color: ${props => props.theme.headerBackground};
  }

  .navbar-inverse .navbar-nav > li > a:hover,
  .navbar-inverse .navbar-nav > li > a:focus,
  .navbar-inverse .navbar-toggle:hover,
  .navbar-inverse .navbar-toggle:focus {
    background-color: ${props => props.theme.headerBackgroundDarken};
    color: ${props =>
      getContrastWhiteBlack(props.theme.headerBackgroundDarken)};
  }

  .navbar-inverse .navbar-nav > li > a {
    background-color: ${props => props.theme.headerBackground};
    color: ${props => props.theme.menuText};
  }

  .dropdown-menu,
  .dropdown-menu > li:not(.active) > a {
    background-color: ${props => props.theme.menuText};
    color: ${props => props.theme.headerBackground};
  }

  .dropdown-menu > li.active > a {
    background-color: ${props => props.theme.brandColor};
    color: ${props => props.theme.brandContrast};
  }

  .dropdown-menu > li > a:hover,
  .dropdown-menu > li > a:focus {
    background-color: ${props => props.theme.menuTextDarken};
    color: ${props => getContrastWhiteBlack(props.theme.menuTextDarken)};
  }

  .navbar-inverse .menuMobile.navbar-nav > li.active > a {
    background-color: ${props => props.theme.brandColor};
    color: ${props => props.theme.brandContrast};
  }
`;
const StyledHasNew = styled.div`
  &:before {
    background-color: ${props => props.theme.brandColor};
  }
`;

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.openHelp = this.openHelp.bind(this);
  }

  openHelp() {
    let currentLocation =
      C_ROUTES.SERVICE_PORTAL_PATH +
      this.props.location.pathname +
      this.props.location.search;
    let requestURI = currentLocation.slice(
      currentLocation.indexOf(C.ROOT_PATH) + 1
    );
    this.props.analyticActions.reportAnalytics([
      C_A.TOP_BAR,
      'help click',
      requestURI
    ]);

    axiosInstance
      .get(`/getHelpPageURL?requestURI=${encodeURIComponent(requestURI)}`)
      .then(response => {
        let windowprops =
          'location=no,menubars=no,toolbars=no,resizable=yes,left=50,top=50,width=800,height=600';
        let url = response.data;
        if (url.indexOf('help/') === 0) {
          url = C.ROOT_PATH + url;
        }
        window.open(url, 'helpWin', windowprops);
      });
  }

  showNews() {
    return (
      !this.props.browser.greaterThan.extraSmall &&
      [C.ROOT_PATH, C.HOME].indexOf(this.props.location.pathname) >= 0 &&
      this.props.news &&
      this.props.news.data
    );
  }
  clearMemory() {
    localStorage.removeItem('showAllFilter');
  }
  getPermissions() {
    let userPhotoToDisplay;
    let mySettings = false;
    let onlineHelp;
    let adminPortal = false;
    let ssp;
    let logoutOrLogin;
    let news = false;
    //get user photo
    if (this.props.userPhoto && this.props.userPhoto.length > 0) {
      if (this.props.userPhotoUpdated) {
        userPhotoToDisplay = `/api/v1/users/me/photo?t1 = ${Date.now()}`;
      } else {
        userPhotoToDisplay = '/api/v1/users/me/photo';
      }
    } else {
      userPhotoToDisplay = defaultUserPhoto;
    }

    let menuTitle = (
      <span>
        <img
          src={userPhotoToDisplay}
          alt={this.props.intlObject['ssp.form.upload.myphoto.user.photo']}
          className={IndexStyle.userPic}
        />{' '}
        <span className={IndexStyle.userName}>{this.props.userName}</span>
      </span>
    );

    let isDesktop = this.props.browser.greaterThan.extraSmall;

    // enable settings nav item
    if (this.props.permissionsData.endUserCanChangeSettings == true) {
      mySettings = isDesktop ? (
        <LinkContainer to={C.MY_SETTINGS_PATH}>
          <MenuItem eventKey={1}>
            {this.props.intlObject['ssp.profile.menu.settings']}
          </MenuItem>
        </LinkContainer>
      ) : (
        <LinkContainer to={C.MY_SETTINGS_PATH}>
          <NavItem eventKey={1}>
            {this.props.intlObject['ssp.profile.menu.settings']}
          </NavItem>
        </LinkContainer>
      );
    }

    // online/offline help
    if (!this.props.permissionsData.hideHelp) {
        onlineHelp = isDesktop ? (
            <MenuItem eventKey={2} onClick={this.openHelp}>
                {this.props.intlObject['ssp.profile.menu.help.new']}
            </MenuItem>
        ) : (
            <NavItem eventKey={2} onClick={this.openHelp}>
                {this.props.intlObject['ssp.profile.menu.help.new']}
            </NavItem>
        );
    }

    // display logout or guest back to login
    if (this.props.isGuest) {
      logoutOrLogin = isDesktop ? (
        <LinkContainer to={'/redirect/login'}>
          <MenuItem eventKey={4}>
            {this.props.intlObject['ssp.profile.menu.login']}
          </MenuItem>
        </LinkContainer>
      ) : (
        <LinkContainer to={'/redirect/login'}>
          <NavItem eventKey={4}>
            {this.props.intlObject['ssp.profile.menu.login']}
          </NavItem>
        </LinkContainer>
      );
    } else {
      logoutOrLogin = isDesktop ? (
        <LinkContainer to={'/redirect/logout'} onClick={this.clearMemory} data-cy="log-out-button">
          <MenuItem eventKey={4}>
            {this.props.intlObject['ssp.profile.menu.logout']}
          </MenuItem>
        </LinkContainer>
      ) : (
        <LinkContainer to={'/redirect/logout'} onClick={this.clearMemory} data-cy="log-out-button">
          <NavItem eventKey={4}>
            {this.props.intlObject['ssp.profile.menu.logout']}
          </NavItem>
        </LinkContainer>
      );
    }

    // enable admin portal nav item
    if (this.props.permissionsData.canAccessAdminPortal == true) {
      adminPortal = isDesktop ? (
        <LinkContainer to={'/redirect/admin'}>
          <MenuItem eventKey={3}>
            {this.props.intlObject['ssp.profile.menu.admin.portal']}
          </MenuItem>
        </LinkContainer>
      ) : (
        <LinkContainer to={'/redirect/admin'}>
          <NavItem eventKey={3}>
            {this.props.intlObject['ssp.profile.menu.admin.portal']}
          </NavItem>
        </LinkContainer>
      );
    }

    // redirect to ssp
    ssp = isDesktop ? (
      <IndexLinkContainer to={C.ROOT_PATH}>
        <MenuItem eventKey={5}>
          {this.props.intlObject['ssp.profile.menu.ssp']}
        </MenuItem>
      </IndexLinkContainer>
    ) : (
      <IndexLinkContainer to={C.ROOT_PATH}>
        <NavItem eventKey={5}>
          {this.props.intlObject['ssp.profile.menu.ssp']}
        </NavItem>
      </IndexLinkContainer>
    );
    //open news on mobile mode
    if (this.showNews()) {
      news = (
        <NavItem
          eventKey={6}
          onClick={() => {
            this.props.actions.updateNewsContext({
              [C_NEWS.OPEN_CLOSED_CLASS_INDEX]:
                1 - this.props.news[C.OPEN_CLOSED_CLASS_INDEX],
              [C_NEWS.HAS_UNREAD]: false
            });
          }}
        >
          {this.props.intlObject['ssp.news.whatsnew']}
        </NavItem>
      );
    }
    // show profile menu dropdown nav item only on desktop
    let menuDisplay;
    if (isDesktop ) {
      if  (this.props.permissionsData.fromF11 !== true) {
        menuDisplay = (
          <Nav pullRight>
            <NavDropdown
              title={menuTitle}
              pullRight
              id="menuDropdown"
              data-cy="menu-dropdown"
              className={IndexStyle.menuDropdown}
            >
              {mySettings}
              {onlineHelp}
              {adminPortal}
              {ssp}
              {logoutOrLogin}
            </NavDropdown>
          </Nav>
        );
      }
    } else {
      menuDisplay = (
        <Nav pullRight className="menuMobile">
          {mySettings}
          {onlineHelp}
          {adminPortal}
          {ssp}
          {news}
          {logoutOrLogin}
        </Nav>
      );
    }

    return { menuDisplay };
  }

  goHome(e) {
    e.preventDefault();
    this.props.analyticActions.reportAnalytics([C_A.TOP_BAR, 'logo click']);
    this.props.history.push(C.ROOT_PATH);
  }

  render() {
    const { menuDisplay } = this.getPermissions();
    let userLogoToDisplay = '';
    let newsIndicator = false;
    //get user logo
    if (this.props.userLogo && this.props.userLogo.length > 0) {
      userLogoToDisplay = this.props.userLogo;
    }
    if (this.showNews()) {
      newsIndicator = this.props.news[C_NEWS.HAS_UNREAD] ? (
        <StyledHasNew className={IndexStyle.hasNew} />
      ) : (
        false
      );
    }
    return (
      <StyledDiv className="navbarWrapper">
        <Navbar
          className={IndexStyle.navbar}
          fluid
          inverse
          staticTop
          collapseOnSelect
        >
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#" onClick={this.goHome.bind(this)}>
                <img
                  className={IndexStyle.logo}
                  src={userLogoToDisplay}
                  title={
                    this.props.intlObject[
                      'ssp.customizeAppearance.mainLogo.title'
                    ]
                  }
                  alt={
                    this.props.intlObject[
                      'ssp.customizeAppearance.mainLogo.title'
                    ]
                  }
                />
              </a>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          {newsIndicator}
          <Navbar.Collapse>{menuDisplay}</Navbar.Collapse>
        </Navbar>
      </StyledDiv>
    );
  }
}

Menu.propTypes = {
  permissionsData: PropTypes.object.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userLogo: PropTypes.string.isRequired,
  browser: PropTypes.object.isRequired,
  intlObject: PropTypes.object.isRequired,
  news: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isGuest: PropTypes.bool.isRequired,
  userPhotoUpdated: PropTypes.bool.isRequired,
  analyticActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    permissionsData: state.app.getIn([C_APP.SSP_PERMISSIONS_LIST]),
    userName: state.user.getIn([C_USER.USER_CALCULATED_NAME]),
    userPhoto: state.user.getIn([C_USER.USER_PHOTO]),
    userPhotoUpdated: state.user.getIn([C_USER.USER_PHOTO_UPDATED]),
    userLogo: state.header.getIn([C_HEADER.USER_LOGO]),
    browser: state.browser,
    intlObject: state.intl.get(intlC.INTL_OBJECT),
    news: state.news.getIn([C_NEWS.NEWS]),
    isGuest: state.user.getIn([C_USER.IS_GUEST])
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(newsActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
    analyticActions: bindActionCreators(AnalyticsAction, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./components/Menu/index.js